import React from 'react';
import styles from './Title.css';

type TitleProps = {
    title: string;
    dataTestId: string;
};
const Title = ({ title, dataTestId }: TitleProps) => {
    return (
        <>
            <div className={styles.pageHeader} data-testid={dataTestId}>
                {title}
            </div>
        </>
    );
};

export default Title;
